const ToggleButton = ({ label, active, onClick, colors }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      flex: "0 0 auto",
      padding: "6px 12px",
      fontSize: "12px",
      fontWeight: 600,
      cursor: "pointer",
      whiteSpace: "nowrap",
      border: "none",
      borderRadius: "4px",
      color: colors.text,
      backgroundColor: active ? colors.toggleActive : "transparent",
      transition: "background-color 120ms ease",
    }}
  >
    {label}
  </button>
);

export default ToggleButton;
